import { captureAttribution } from '@/renderer/utils/stat/attribution';
import { initMixpanel } from '@/renderer/utils/stat/mixp';

export default function onAfterRenderClient(_pageContext: Vike.PageContext) {
  initMixpanel(); // this will process the queue up to now

  // Persist campaign attribution (utm_*/twclid) on a campaigned landing so it's
  // available to attach to any later order. No-op on plain in-app navigation.
  captureAttribution();

  //   MixpanelProxy.track_pageview();
}
